import { motion } from 'framer-motion';
import { ScaleIcon, ExclamationTriangleIcon, CalendarDaysIcon } from '@heroicons/react/24/outline';

const CATEGORY_ICONS = {
  review: ScaleIcon,
  followup: ExclamationTriangleIcon,
  scheduled: CalendarDaysIcon,
};

const TimelineDivider = ({ item, isFirst }) => {
  const isMonthDivider = item.type === 'month-divider';
  const isCategoryDivider = item.type === 'category-divider';

  // Use regular div for first divider to avoid jarring animation
  const DividerComponent = isFirst ? 'div' : motion.div;
  const dividerProps = isFirst ? {} : {
    layout: true,
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 }
  };

  // Action Center section header — a prominent, labelled group heading
  if (isCategoryDivider) {
    const Icon = CATEGORY_ICONS[item.icon] || ScaleIcon;
    return (
      <DividerComponent
        {...dividerProps}
        className={`flex items-center gap-2.5 ${isFirst ? 'mb-3' : 'mt-6 mb-3'}`}
      >
        <Icon className="w-5 h-5 text-base-content/70" />
        <span className="text-sm font-bold text-base-content uppercase tracking-wide">
          {item.label}
        </span>
        {item.count > 0 && (
          <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-base-content/10 text-base-content/70">
            {item.count}
          </span>
        )}
        <div className="flex-1 h-px bg-base-content/15"></div>
      </DividerComponent>
    );
  }

  if (isMonthDivider) {
    return (
      <DividerComponent
        {...dividerProps}
        className="flex items-center gap-3 my-4"
      >
        <div className="flex-1 h-px bg-base-content/20"></div>
        <span className="text-xs font-semibold text-base-content/60 px-3 uppercase tracking-wider">
          {item.label}
        </span>
        <div className="flex-1 h-px bg-base-content/20"></div>
      </DividerComponent>
    );
  }

  // Day divider (subtle)
  return (
    <DividerComponent
      {...dividerProps}
      className="flex items-center gap-3 my-2"
    >
      <div className="flex-1 h-px bg-base-content/10"></div>
      <span className="text-sm font-medium text-base-content/50 px-3">
        {item.label}
      </span>
      <div className="flex-1 h-px bg-base-content/10"></div>
    </DividerComponent>
  );
};

export default TimelineDivider;
